import { isObject } from "lodash";
import { dockPadEntityMapToList } from "../containers/DockPadFormTemplates";
import { Constraint } from "../models/Constraint";
import { RowGroup } from "../models/Lookahead";
import { LookaheadTag } from "../models/LookaheadTag";

const _ = require('lodash');

function mapToList(entityMap) {
    const list = []
    for (const key in entityMap) {
        const item = entityMap[key]
        if (!isObject(item)) continue
        item.uid = key
        list.push(item)
    }
    return list
}
export function addRowGroupFunc(tags: { [x: string]: LookaheadTag | Constraint; },  rowGroups: Record<string, RowGroup>, direction: string, index: number, projectId: any, lookaheadId: any) {
    
    const tagList = mapToList(tags)

    const tagsByIndex = _.groupBy(tagList, 'indexId');


    const updates = {};

    if (direction == 'above') {

        Object.keys(tagsByIndex).forEach(indexStr => {
            const tagIndex = parseInt(indexStr);
            if (tagIndex >= index) {
                const indexTags = tagsByIndex[indexStr];

                const newIndex = tagIndex + 1;
                indexTags.forEach(tag => {
                    const tagId = tag.uid;
                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = newIndex;

                });
            }
        });

        Object.keys(rowGroups).forEach(rowId => {
            const rowGroup = rowGroups[rowId]
            if(index >= rowGroup.start && index <= rowGroup.end) {

                const newGroup = {...rowGroup}
                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/end`] = newGroup.end + 1

            } else {

                if(rowGroup.start > index) {

                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/start`] = rowGroup.start + 1
                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/end`] = rowGroup.end + 1
    
                }
            }

            


        })
    }

    if (direction == 'below') {

        Object.keys(tagsByIndex).forEach(indexStr => {
            const tagIndex = parseInt(indexStr);
            if (tagIndex > index) {
                const indexTags = tagsByIndex[indexStr];

                const newIndex = tagIndex + 1;
                indexTags.forEach(tag => {
                    const tagId = tag.uid;
                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = newIndex;

                });


            }
        });

        Object.keys(rowGroups).forEach(rowId => {
            const rowGroup = rowGroups[rowId]
            if(index >= rowGroup.start && index <= rowGroup.end) {

                const newGroup = {...rowGroup}
                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/end`] = newGroup.end + 1

            } else {

                if(rowGroup.start > index) {

                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/start`] = rowGroup.start + 1
                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/end`] = rowGroup.end + 1
    
                }
            }

            


        })
    }
    return updates;
}

export function deleteRowGroupFunc(tags: { [x: string]: LookaheadTag | Constraint; },  rowGroups: Record<string, RowGroup>, index: number, projectId: any, lookaheadId: any) {
    
    const tagList = mapToList(tags)

    const tagsByIndex = _.groupBy(tagList, 'indexId');

    if(!!tagsByIndex[index]) {
        return null
    }


    const updates = {};


    Object.keys(tagsByIndex).forEach(indexStr => {
        const tagIndex = parseInt(indexStr);
        if (tagIndex > index) {
            const indexTags = tagsByIndex[indexStr];

            const newIndex = tagIndex - 1;
            indexTags.forEach(tag => {
                const tagId = tag.uid;
                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = newIndex;

            });
        }
    });

    Object.keys(rowGroups).forEach(rowId => {
        const rowGroup = rowGroups[rowId]
        if(index >= rowGroup.start && index <= rowGroup.end) {

            const newGroup = {...rowGroup}
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/end`] = newGroup.end - 1

        } else {

            if(rowGroup.start > index) {

                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/start`] = rowGroup.start - 1
                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowId}/end`] = rowGroup.end - 1

            }
        }

        


    })
    

    return updates;
}

export function moveGroupFunc(tags: { [x: string]: LookaheadTag | Constraint; },  rowGroups: Record<string, RowGroup>, direction: string, index: number, projectId: any, lookaheadId: any) {
    const tagList = mapToList(tags)

    const tagsByIndex = _.groupBy(tagList, 'indexId')
        

    let foundRowGroup: RowGroup | Null
    Object.keys(rowGroups).forEach(rowGroupId => {
        const rowGroup = rowGroups[rowGroupId]
        if(rowGroup.start == index) {
            foundRowGroup = rowGroups[rowGroupId]
            foundRowGroup.uid = rowGroupId
        }
    })


    if(!foundRowGroup || (foundRowGroup.start == 0 && direction == "up"))
    {
        return {}
    }

    //find i group above
    let groupAbove: RowGroup | Null
    Object.keys(rowGroups).forEach(rowGroupId => {
        const rowGroup = rowGroups[rowGroupId]
        const additive = direction == 'up' ? -1 : 1

        if(direction == 'up') {
            if(rowGroup.end == foundRowGroup.start + additive) {
                groupAbove = rowGroup
                groupAbove['uid'] = rowGroupId
            }
        } 

        if(direction == 'down') {
            if(rowGroup.start == foundRowGroup.end + additive) {
                groupAbove = rowGroup
                groupAbove['uid'] = rowGroupId
            }
        }

        
    })    

    let updates = {}

    let foundRowGroupStart: number | null = null
    let groupAboveStart: number | null = null
    if(!!groupAbove) {
        if(direction == 'up') {
            const groupAboveDistance = groupAbove.end - groupAbove.start
            const foundGroupDistance = foundRowGroup.end - foundRowGroup.start

            foundRowGroupStart = groupAbove.start
            groupAboveStart = groupAbove.start + foundGroupDistance + 1
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${foundRowGroup.uid}/start`] = groupAbove.start
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${foundRowGroup.uid}/end`] = groupAbove.start + foundGroupDistance

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${groupAbove.uid}/start`] = groupAbove.start + foundGroupDistance + 1
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${groupAbove.uid}/end`] = groupAbove.start + foundGroupDistance + 1 + groupAboveDistance

            
        } else { 


            const groupAboveDistance = groupAbove.end - groupAbove.start
            const foundGroupDistance = foundRowGroup.end - foundRowGroup.start

            foundRowGroupStart = foundRowGroup.start + groupAboveDistance + 1
            groupAboveStart = foundRowGroup.start

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${groupAbove.uid}/start`] = foundRowGroup.start
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${groupAbove.uid}/end`] = foundRowGroup.start + groupAboveDistance

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${foundRowGroup.uid}/start`] = foundRowGroup.start + groupAboveDistance +1
            
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${foundRowGroup.uid}/end`] = foundRowGroup.start + groupAboveDistance + 1 + foundGroupDistance


        }
        
    } else {
        Object.keys(rowGroups).forEach(rowGroupId => {
            const rowGroup = rowGroups[rowGroupId]
    
            if(foundRowGroup.start<= rowGroup.start && foundRowGroup.end>= rowGroup.start){
                const start = direction == 'up' ? rowGroup.start - 1 : rowGroup.start + 1
                const end = direction == 'up' ? rowGroup.end - 1 : rowGroup.end + 1
    
                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowGroupId}/start`] = start 
                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${rowGroupId}/end`] = end 
    
                
            }
        })
    }
    
    if(!!groupAbove) {
        
        _.range(foundRowGroup.start, foundRowGroup.end+1).forEach((range_index: string | number) => {
            const rangeIndexInt = parseInt(range_index)
            const distance = rangeIndexInt - foundRowGroup.start

            const tags = !!tagsByIndex[rangeIndexInt] ? tagsByIndex[rangeIndexInt] : []

            tags.forEach(tag => {
                const tagId = tag.uid
                const adjust = direction == 'up' ?  - 1 :  1


                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = foundRowGroupStart + distance
            });
        })


        _.range(groupAbove.start, groupAbove.end+1).forEach((range_index: string | number) => {
            const rangeIndexInt = parseInt(range_index)
            const distance = rangeIndexInt - groupAbove.start

            const tags = !!tagsByIndex[rangeIndexInt] ? tagsByIndex[rangeIndexInt] : []

            tags.forEach(tag => {
                const tagId = tag.uid

                updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = groupAboveStart + distance
            });
        })

    } else {
        _.range(foundRowGroup.start, foundRowGroup.end+1).forEach((range_index: string | number) => {
            if(foundRowGroup.start<= range_index && foundRowGroup.end>= range_index){
                const i = `${range_index}`
                const tags = !!tagsByIndex[i] ? tagsByIndex[i] : []

                tags.forEach(tag => {
                    const tagId = tag.uid
                    const adjust = direction == 'up' ?  - 1 :  1

                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = parseInt(range_index) + adjust

                });

            }

        })

        if(!groupAbove) {
            if(!!tagsByIndex[index - 1] && direction === 'up') {
                const tags = tagsByIndex[index - 1]
        
                //const addRowUpdates = addRowGroupFunc(tags, rowGroups, 'below', foundRowGroup.end - 1, projectId, lookaheadId)
                //updates = {...updates, addRowUpdates}
        
                tags.forEach(tag => {
                    const tagId = tag.uid
        
                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = foundRowGroup.end
        
                })
        
            } 

            if(!!tagsByIndex[foundRowGroup.end + 1] && direction === 'down') {
                const tags = tagsByIndex[foundRowGroup.end + 1]
        

        
                tags.forEach(tag => {
                    const tagId = tag.uid
        
                    updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = foundRowGroup.start
        
                })
            }

        }

        
    }

    

    

    return updates
}


// WEBPACK FOOTER //
// ./src/actions/lookahead.actions.helper.ts